/* eslint-disable */
/**
 * Converts the plain text a manager types into email-safe HTML.
 *
 * Managers don't know HTML, so the input is never treated as markup — everything
 * is escaped first, then a small deterministic set of conventions is styled:
 *
 *   **bold**            → <strong>
 *   *italic* / _italic_ → <em>
 *   - item              → bulleted list (consecutive "- " lines group into one list)
 *   blank line          → new paragraph
 *   single newline      → line break
 *   https://…           → clickable link
 *
 * All output carries inline styles (email clients ignore stylesheets). Pure
 * string logic — no DOM required, works identically everywhere.
 */

const P_STYLE =
  "margin:0 0 14px;font-size:14px;line-height:22px;color:#374151;";
const UL_STYLE = "margin:0 0 14px;padding:0 0 0 22px;";
const LI_STYLE = "margin:4px 0;font-size:14px;line-height:22px;color:#374151;";
const A_STYLE = "color:#E85936;text-decoration:underline;";

export function escapeHtml(text: string): string {
  return text
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

function inlineFormat(escaped: string): string {
  return escaped
    .replace(/\*\*([^*\n]+)\*\*/g, "<strong>$1</strong>")
    .replace(/(^|[\s(])\*([^*\n]+)\*(?=$|[\s).,!?:;])/gm, "$1<em>$2</em>")
    .replace(/(^|[\s(])_([^_\n]+)_(?=$|[\s).,!?:;])/gm, "$1<em>$2</em>")
    .replace(/(https?:\/\/[^\s<]+)/g, `<a href="$1" style="${A_STYLE}">$1</a>`);
}

export function textToEmailHtml(text: string): string {
  const lines = inlineFormat(escapeHtml(text.replace(/\r\n/g, "\n"))).split(
    "\n"
  );
  const out: string[] = [];
  let paragraph: string[] = [];
  let listItems: string[] = [];

  const flushParagraph = () => {
    if (paragraph.length) {
      out.push(`<p style="${P_STYLE}">${paragraph.join("<br>")}</p>`);
      paragraph = [];
    }
  };
  const flushList = () => {
    if (listItems.length) {
      out.push(
        `<ul style="${UL_STYLE}">${listItems
          .map((i) => `<li style="${LI_STYLE}">${i}</li>`)
          .join("")}</ul>`
      );
      listItems = [];
    }
  };

  for (const line of lines) {
    const listMatch = line.match(/^\s*-\s+(.*)$/);
    if (listMatch) {
      flushParagraph();
      listItems.push(listMatch[1]!);
    } else if (!line.trim()) {
      flushParagraph();
      flushList();
    } else {
      flushList();
      paragraph.push(line);
    }
  }
  flushParagraph();
  flushList();
  return out.join("");
}
